import { useEffect, useRef, useState } from 'react';
import Lottie from 'lottie-react';
import { AnimatePresence, delay, motion, useInView } from 'framer-motion';
import { IoSend } from 'react-icons/io5';
import { RiSendPlane2Line } from 'react-icons/ri';

import Navigation from '../components/Navigation';
import Ptn from '../components/Ptn';
import Intro from '../components/Intro';
import ScrollInfo from '../components/ScrollInfo';
import header from '../assets/img/header.jpg'
import justiceScales from '../assets/img/justiceScales.webp'
import ladyJusticeDesk from '../assets/img/ladyJusticeDesk.webp'
import ladyJustice from '../assets/img/ladyJustice.webp'
import lawyerWig from '../assets/img/lawyerWig.webp'
import gavelArt from '../assets/img/gavelArt.webp'

import placeholderImage from '../assets/img/placeholderImage.webp'
// import teamBg from '../assets/img/teamBg.png'
// import contactUs from '../assets/img/contactUs.webp'
import { useText } from '../components/TextContext';

import { getUserText } from "../firebase/dbServices";
import { auth } from "../firebase/firebase";

import { useNavigate } from "react-router-dom";

import { getFirestore, doc, getDoc } from "firebase/firestore";
import Contact from '../components/Contact';

const db = getFirestore(); // Ensure db is initialized

const testFetch = async () => {
    const docRef = doc(db, "userTexts", "nsiWbzU1NNY744HYlHOzkyI0Bl93");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
        console.log("Firestore data:", docSnap.data());
    } else {
        console.log("Document not found.");
    }
};

testFetch();

const Home = ({
    isScrolled
}) => {

    const whatWeDoRef = useRef(null);
    const infoRef = useRef(null)
    const isInView = useInView(infoRef, { once: true });

    const { savedText } = useText();

    const [userText, setUserText] = useState({ title: "", text: "", imageURL: "" });

    const fadeIn = {
        initial: {
            opacity: 0,
            y: 30
        },
        animate: {
            opacity: 1,
            y: 0,
            transition: {
                ease: "easeInOut",
                duration: 0.35,
                delay: 1
            }
        },
        exit: {
            opacity: 0,
            y: 30,
            transition: {
                ease: "easeInOut",
                duration: 0.75
            }
        },
    };

    const parentVariants = {
        hidden: {
            opacity: 0,
            y: 30
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                // duration: 0.5,
                staggerChildren: 0.5,
                when: "beforeChildren",
            },
        },
    };

    const childVariants = {
        hidden: {
            opacity: 0,
            y: 30
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.5
            }
        },
    };

    /* useEffect(() => {
        console.log('Home Page re-rendered with savedText:', savedText);
    }, [savedText]); */

    const navigate = useNavigate();

    useEffect(() => {
        const fetchUserText = async () => {
            try {
                const docRef = doc(db, "userTexts", "nsiWbzU1NNY744HYlHOzkyI0Bl93");
                const docSnap = await getDoc(docRef);

                console.log("Fetching Firestore data...");
                if (docSnap.exists()) {
                    console.log("Fetched data:", docSnap.data());
                    setUserText(docSnap.data());
                } else {
                    console.log("No such document!");
                    setUserText({ title: "", text: "", imageURL: "" });
                }
            } catch (error) {
                console.error("Error fetching document:", error);
            }
        };

        fetchUserText();
    }, []);


    return (
        <div>
            <h1 className='h-[1px] w-[1px] overflow-hidden absolute opacity-0'>
                Murage Juma & Company Advocates
            </h1>
            <AnimatePresence>
                {/* <div className="fixed top-0 left-0 bgPtn w-full h-screen z-[100] mix-blend-multiply" /> */}
                <motion.div
                    variants={fadeIn}
                    initial="initial"
                    animate="animate"
                    exit="exit"
                >
                    <section
                        id='home'
                    >
                        <div
                            className='relative z-[900] w-full h-[6rem]'
                        >
                            <Navigation
                                isScrolled={isScrolled}
                            />
                        </div>
                    </section>
                    <div
                        className='absolute top-0 left-0 z-[50] w-full overflow-hidden'
                    >
                        <div className="fixed top-0 left-0 xs:bg-gradient-to-t lg:bg-gradient-to-r from-bgSky via-bgSky to-bgSky/0 xs:w-full lg:w-[85%] 2xl:w-[75%] h-full z-20" />
                        <img
                            src={header}
                            alt="Lady Justice"
                            className='relative xs:h-[45vh] xsp:h-[52vh] md:h-[60vh] lg:h-[100vh] xl:h-[95vh] 2xl:h-screen lg:translate-x-[35%] 2xl:translate-x-[35%] 4xl:translate-x-[37.5%] 5xl:translate-x-[45%] 6xl:translate-x-[55%] z-10 xs:mt-[3.5rem] lg:mt-[2.5rem] xl:mt-[3rem] 2xl:mt-[2.5rem] object-cover mask-gradientHeader'
                        />
                    </div>
                    <Ptn
                        isScrolled={isScrolled}
                    />
                    {/* <div className="fixed top-0 left-0 bgPtn w-full h-screen z-[100] mix-blend-color-burn opacity-100" /> */}
                    <Intro />



                    <ScrollInfo
                        fadeIn={fadeIn}
                        whatWeDoRef={whatWeDoRef}
                    />

                    {/* What We Offer Info */}

                    <div
                        className='4xl:px-[0%]'
                    >
                        <motion.div
                            ref={infoRef}
                            variants={parentVariants}
                            initial="hidden"
                            whileInView="visible" // Automatically animates when in view
                            viewport={{ once: true, amount: 0.1 }}
                            className='relative z-[500] glsOutline h-auto pgMx rounded-tl-[24px] rounded-tr-[12px] xs:rounded-b-[16px] lg:rounded-b-[24px] shadow-2xl'
                        >
                            <section
                                id='what-we-offer'
                            >
                                <div
                                    ref={whatWeDoRef}
                                    variants={childVariants}
                                    className="relative grid xs:grid-cols-1 lg:grid-cols-2 px-[] z-[500] xs:mt-[1rem] xsp:-mt-[1rem] lg:mt-[6rem] xl:mt-[9rem] 2xl:mt-[11.5rem]">
                                    <motion.div
                                        variants={childVariants}
                                        className='relative xs:h-[15rem] md:h-[25rem] lg:h-[28rem] xl:h-[32rem] 2xl:h-[42.5rem] 3xl:h-[37.5rem] overflow-hidden xs:rounded-t-[24px] lg:rounded-tr-[0] lg:rounded-tl-[24px]'>
                                        <div className="absolute top-0 left-0 bg-gradient-to-b from-black/80 via-black/0 to-black/0 z-[600] h-full w-full" />
                                        <motion.img
                                            variants={childVariants}
                                            src={justiceScales}
                                            alt="Justice Scales"
                                            className='object-cover w-full h-full'
                                        />
                                    </motion.div>
                                    <motion.div
                                        variants={childVariants}
                                        className='chunkStyl'>
                                        <div
                                            className='flex flex-row items-center justify-center space-x-[1rem]'
                                        >
                                            <h5
                                                className="playfair introTitle introTitleTxtSize"
                                            >
                                                What We Have to Offer
                                            </h5>
                                            {/* <hr className='w-full h-[1px] mt-[5px] border-primaryGreen/80' /> */}
                                        </div>
                                        <div className='titleUnderline' />
                                        <p
                                            className='relative z-[600] outfit bodyTxt xs:mt-[1rem] lg:mt-[1rem] 2xl:mt-[1.5rem] text-slate-600 text-justify'
                                        >
                                            A boutique legal practice with a focused commitment to the legal and commercial needs of our Clients. A vibrant team of Advocates and Support Staff contribute to the overall success of the firm.
                                            <br />
                                            <br />
                                            MJC is set apart because we offer, among others, a “one stop” legal advisory and strategic solution boutique in the multifarious legal practice areas of today’s world.
                                            <br />
                                            <br />
                                            Our innovative approach has helped Clients seamlessly tread through and prosper in the arena of real estate acquisition sales and development. We understand the industry and remain abreast of emerging legal issues and developments that could impact our Clients’ businesses.
                                            <br />
                                            <br />
                                            Our Clients include various Institutions, Property Developers, Private companies and Individuals. We have the added benefit of a strong network of Legal and other Consultants within the country and the region who we can call upon with a view to providing you with added value ancillary to the high quality of service.
                                        </p>
                                        <div className='absolute -top-[15%] xs:-right-[40%] md:-right-[55%] lg:-right-[40%] w-full h-full mix-blend-difference opacity-20 z-[500]'>
                                            <img src={ladyJustice} alt="Lady Justice" />
                                        </div>
                                    </motion.div>
                                </div>
                            </section>
                            <section
                                id='practice-areas'
                            >
                                <motion.div
                                    ref={infoRef}
                                    variants={parentVariants}
                                    initial="hidden"
                                    whileInView="visible" // Automatically animates when in view
                                    viewport={{ once: true, amount: 0.1 }}
                                    className="relative grid xs:grid-cols-1 lg:grid-cols-2 px-[] z-[500] lg:mb-[3rem] lg:mt-0">
                                    <motion.div
                                        variants={childVariants}
                                        className='xs:block lg:hidden relative xs:h-[15rem] md:h-[25rem] lg:h-[48rem] xl:h-[52rem] overflow-hidden lg:rounded-br-[24px]'>
                                        <div className="absolute top-0 left-0 bg-gradient-to-b from-black/80 via-black/0 to-black/0 z-[600] h-full w-full" />
                                        <img
                                            src={ladyJusticeDesk}
                                            alt="Lady Justice on Desk"
                                            className='object-cover w-full h-full'
                                        />
                                    </motion.div>

                                    {/* Practice Areas Info */}
                                    <motion.div
                                        variants={childVariants}
                                        className='chunkStyl xs:rounded-b-[16px] lg:rounded-br-[0] lg:rounded-bl-[24px]'>
                                        <div
                                            className='flex flex-row items-center justify-center space-x-[1rem]'
                                        >
                                            <h5
                                                className="playfair introTitle introTitleTxtSize"
                                            >
                                                Our Practice Areas
                                            </h5>
                                            {/* <hr className='w-full h-[1px] mt-[5px] border-primaryGreen/80' /> */}
                                        </div>
                                        <div className='w-full h-[1px] bg-gradient-to-r from-primaryRichGreen to-primaryRichBlue opacity-30 mt-[1rem] mb-[1rem]' />
                                        <ul
                                            className='relative outfit bodyTxt xs:pl-[1rem] lg:pl-[2rem] xs:my-[0.9rem] lg:mb-0 lg:mt-[1rem] 2xl:mt-[1.5rem] text-slate-600 xs:text-left lg:text-justify list-disc xs:space-y-[0.25rem] lg:space-y-[0.5rem] z-[600]'
                                        >
                                            <li>Project Development and Finance – Agri-business</li>
                                            <li>Banking and Project Finance Securities perfection</li>
                                            <li>Sale of Property and Assets</li>
                                            <li>Commercial and Residential Leases and Agreements</li>
                                            <li>General and Specific Commercial contracts</li>
                                            <li>Advisory on Governmental and Parastatal Contracts</li>
                                            <li>Energy and Natural Resource Law Research and Advisory:</li>
                                            <ol
                                                className='list-decimal pl-[1.5rem] space-y-[0.5rem]'
                                            >
                                                <li>Upstream and Downstream Oil and Gas Contract Review and Advisory</li>
                                                <li>Oil and Gas Legislative Framework Review, Development and Advisory</li>
                                                <li>Investment Advisory in the Oil and Gas Sector</li>
                                            </ol>
                                            <li>Alternative Dispute Resolution and Advisory on Conflict Resolution around Project Sites</li>
                                            <li>Environmental Policy Review, Development and Advisory</li>
                                            <li>Intellectual Property Law</li>
                                            <li>Succession law - Probate and Administration</li>
                                            <li>Family Law</li>
                                            <li>Legal Entity formation – Companies, Trusts, LLPs etc.</li>
                                            <li>Debt Collection</li>
                                            <li>Civil and Commercial Litigation</li>
                                            <li>International Investor Relocation Advisory</li>
                                            <li>Immigration Law Advisory and Ancillary Services</li>
                                        </ul>
                                        <div
                                            className='absolute -top-[15%] xs:-right-[45%] md:-right-[60%] lg:-right-[45%] w-full h-full mix-blend-multiply opacity-5 z-[500]'>
                                            <img
                                                src={lawyerWig}
                                                alt="Lawyer Wig"
                                            />
                                        </div>
                                    </motion.div>

                                    <motion.div
                                        variants={childVariants}
                                        className='xs:hidden lg:block relative lg:h-[41rem] xl:h-[49rem] 2xl:h-[56rem] 3xl:h-[52rem] 4xl:h-[50rem] overflow-hidden rounded-br-[24px]'>
                                        <div className="absolute top-0 left-0 bg-gradient-to-b from-black/80 via-black/0 to-black/0 z-[600] h-full w-full" />
                                        <img
                                            src={ladyJusticeDesk}
                                            alt="Lady Justice on Desk"
                                            className='object-cover w-full h-full'
                                        />
                                    </motion.div>
                                </motion.div>
                            </section>
                        </motion.div>



                        {/* Team Information */}
                        <section
                            id='our-team'
                        >
                            <div className="divider" />
                            <motion.div
                                variants={parentVariants}
                                initial="hidden"
                                whileInView="visible" // Automatically animates when in view
                                viewport={{ once: true, amount: 0.1 }}
                                className='bg-gradient-to-b from-white to-bgSky/60 shadow-2xl border-[3px] border-white glsOutline relative z-[500] pgMx xs:py-[1rem] lg:py-[1rem] xl:py-[1.5rem] 2xl:py-[1.75rem] md:px-[4rem] lg:px-[1rem] 2xl:px-[3rem] xs:rounded-[16px] lg:rounded-[24px] overflow-hidden'
                            >
                                {/* <div className='absolute -top-[10%] xs:-right-[0%] md:-right-[55%] lg:-right-[70%] w-full h-full mix-blend-difference opacity-40 z-[500]'>
                                    <img src={ladyJustice} alt="Lady Justice" />
                                </div> */}

                                {/* <div className='absolute -top-[5%] -right-[47.5%] w-full h-full mix-blend-luminosity opacity-10 z-[500]'>
                        <img src={teamBg} alt="Lady Justice" />
                      </div> */}
                                <div className='relative z-[700] flex flex-row items-center justify-center xs:px-[1rem] lg:px-[3rem] xs:py-[1rem] 2xl:py-[1.25rem]'>
                                    <div className='xs:w-[30%] md:w-[40%] lg:w-[40%] h-[1px] bg-gradient-to-r from-primaryRichBlue to-primaryRichGreen opacity-30' />
                                    <h6
                                        className="playfair xs:w-[40%] lg:w-[20%] whitespace-nowrap text-center introTitleTxtSize bg-gradient-to-b from-primaryRichBlue via-primaryRichBlue to-primaryGreen bg-clip-text text-transparent"
                                    >
                                        Our Team
                                    </h6>
                                    <div className='xs:w-[30%] md:w-[40%] lg:w-[40%] h-[1px] bg-gradient-to-r from-primaryRichGreen to-primaryRichBlue opacity-30' />
                                </div>
                                <div className="relative grid xs:grid-cols-1 lg:grid-cols-2 xs:px-[1.5rem] lg:px-[2rem] xl:px-[3rem] z-[500] xs:mt-[1rem] 2xl:mt-[1.5rem]">
                                    <motion.div
                                        variants={childVariants}
                                        className='flex flex-col items-start justify-center lg:border-r lg:border-slate-400/30 lg:pr-[2rem] xl:pr-[4rem] xs:pb-[2rem] lg:pb-[3rem]'
                                    >
                                        <p
                                            className='outfit teamName'
                                        >
                                            Joseph Nicholas C. Murage
                                        </p>
                                        <p
                                            className='alata teamPosition'
                                        >
                                            Managing Partner
                                        </p>
                                        <p
                                            className='outfit text-slate-700 mt-[1rem] text-justify bodyTxt'
                                        >
                                            Duly admitted to the High Court of Kenya, Nicholas holds a Postgraduate Law Degree - Merit (LLM) in Oil and Gas Law and Policy from the Center for Energy Petroleum Mineral Law and Policy (CEPMLP) at the University of Dundee in Scotland UK and is also a Law Graduate of Moi University, Kenya.
                                            <br />
                                            <br />
                                            Joseph, previously a Partner at Waruhiu and Company Advocates also worked at UNEP-DELC (Department of Environmental Law and Conventions), Ndungu Njoroge & Kwach and Bank of Africa Kenya Limited. His main areas of practice include Energy and Natural Resource Law Policy Development, Research and Advisory, Property Law (and Conveyance), Civil and Commercial Litigation, Joint Venture Structuring and advisory, Debt Collection, Probate and Administration, Immigration Advisory and Foreign Direct Investment Advisory.
                                            <br />
                                            <br />
                                            Recently appointed as a Continuous Professional Development (CPD for Advocates in Kenya) Trainer as well as a Lead Trainer on the SIRD Programme ran by the Law Society of Kenya in partnership with the Canadian Bar Association, Joseph has extended MJC’s services into capacity building and enhancing community development through capacity building.
                                        </p>
                                        <p
                                            className='outfit mt-[1rem] text-slate-700 bodyTxt'
                                        >
                                            Email:&nbsp;
                                            <a
                                                href="mailto:joe@jncmlaw.co.ke"
                                                className='text-blue-700 underline underline-offset-2 decoration-blue-700'
                                            >
                                                joe@jncmlaw.co.ke
                                            </a>
                                        </p>
                                    </motion.div>
                                    <motion.div
                                        variants={childVariants}
                                        className='flex flex-col items-start justify-start lg:pl-[2rem] xl:pl-[4rem] xs:pb-[2rem] lg:pb-0'
                                    >
                                        <p
                                            className='outfit teamName'
                                        >
                                            Juma Kagoro
                                        </p>
                                        <p
                                            className='alata teamPosition'
                                        >
                                            Partner
                                        </p>
                                        <p
                                            className='outfit text-slate-700 mt-[1rem] text-justify bodyTxt'
                                        >
                                            An Advocate the High Court of Kenya, Juma is a Graduate (LLB. Hons) of Uganda Christian University, Kampala, Uganda. He also holds a Postgraduate Diploma from the Kenya School of law.
                                            <br />
                                            <br />
                                            His main areas of practice include Civil and Commercial Litigation, Criminal Litigation – White Collar, Industrial and Labor Law Litigation, Company Formation, Probate and Administration, Intellectual Property, Debt Collection and Landlord Tenant Disputes.
                                            <br />
                                            <br />
                                            Juma has also made a name for himself in Constitutional Law and Election Petition Litigation having successfully defended several matters in various regions within Kenya.
                                        </p>
                                        <p
                                            className='outfit mt-[1rem] text-slate-700 bodyTxt'
                                        >
                                            Email:&nbsp;
                                            <a
                                                href="mailto:jkagoro@jncmlaw.co.ke"
                                                className='text-blue-700 underline underline-offset-2 decoration-blue-700'
                                            >
                                                jkagoro@jncmlaw.co.ke
                                            </a>
                                        </p>
                                    </motion.div>
                                </div>
                                <div
                                    className='xs:px-[1.5rem] lg:px-[2rem] xl:px-[3rem] pb-[1rem]'
                                >
                                    <motion.div
                                        variants={childVariants}
                                        className="relative w-full lg:border-t border-slate-400/30 lg:pt-[2rem] pb-[3rem] z-[500]"
                                    >
                                        <p
                                            className='outfit teamName'
                                        >
                                            John Patrick Machira
                                        </p>
                                        <p
                                            className='alata teamPosition'
                                        >
                                            Consultant
                                        </p>
                                        <p
                                            className='outfit text-slate-700 mt-[1rem] text-justify bodyTxt'
                                        >
                                            Admitted as an Advocate of the High Court of Kenya in 1975, JP has a cumulative real sector experience of 41 years. MJC is honored to have access to JP’s wealth of knowledge in Property Law and Conveyancing, Civil and Commercial Litigation and overall litigation strategic planning. JP Machira has made a name for himself in the legal practice in Kenya and is one of, if not the foremost authorities on the law of Torts having participated in and successfully contributed to the development of several precedent setting cases in Kenya in the law of Libel and Defamation.
                                        </p>
                                        {/* <p
                          className='outfit mt-[1rem] text-slate-700 text-[0.9rem]'
                        >
                          Email:&nbsp;
                          <a
                            href="mailto:jkagoro@jncmlaw.co.ke"
                            className='text-blue-700 underline underline-offset-2 decoration-blue-700'
                          >
                            jkagoro@jncmlaw.co.ke
                          </a>
                        </p> */}


                                    </motion.div>
                                    <p
                                        className='relative z-[500] outfit bodyTxt !font-[600] text-center text-slate-700'
                                    >
                                        The foregoing Team leaders are supported by a vibrant team of Associates and Paralegals who ensure that all briefs are handled professionally and instructions executed seamlessly.
                                    </p>
                                    {/*  <div className="relative z-[500] w-full h-[1px] bg-gradient-to-r from-primaryRichBlue via-primaryRichGreen to-primaryRichBlue opacity-30"/> */}

                                </div>
                            </motion.div>

                        </section>



                        {/* Client Care Information */}

                        <div className="divider" />

                        <div
                            className='grid xs:grid-cols-1 lg:grid-cols-[50%_50%] xl:grid-cols-[45%_55%] pgMx lg:space-x-[2rem]'
                        >
                            <div
                                className='bg-gradient-to-b from-white to-bgSky/60 shadow-2xl border-[3px] border-white glsOutline relative z-[500] 2xl:py-[1.5rem] xs:px-[1.5rem] md:px-[5rem] lg:px-[1rem] 2xl:px-[3rem] xs:rounded-[12px] lg:rounded-[24px]'
                            >
                                <section
                                    id='client-care'
                                >
                                    <div
                                        className='relative z-[700] flex flex-row items-center justify-start px-[2rem] pt-[1.5rem]'
                                    >
                                        {/* <div className='w-[40%] h-[1px] bg-gradient-to-r from-primaryRichBlue to-primaryRichGreen opacity-30' /> */}
                                        <h6
                                            className="playfair introTitle introTitleTxtSize"
                                        >
                                            Client Care
                                        </h6>
                                        {/* <div className='w-[60%] h-[1px] bg-gradient-to-r from-primaryRichGreen to-primaryRichBlue opacity-30' /> */}
                                    </div>
                                    <div
                                        className='relative z-[700] flex flex-col items-center justify-center lg:px-[2rem]'>

                                        <div className='titleUnderline' />
                                        <p
                                            className='outfit bodyTxt pb-[2rem] text-justify'
                                        >
                                            At MJC, we believe in a personalized approach to Client care and service. All initial instructions are received by a Partner who will retain overall responsibility and oversight over the matter and will be your contact for issuing instructions, receiving updates, providing advice on any matters and any relevant information required.
                                            <br />
                                            <br />
                                            Our diverse Client Base includes but is not limited to National and Multi-National Companies within the continent and beyond.
                                            <br />
                                            <br />
                                            All those who work at MJC adhere to and strictly observe, all professional codes of conduct and ethics. Efficiency, Effectiveness, Integrity and Professionality are our core values when it comes to service delivery.
                                        </p>
                                    </div>
                                </section>

                                <section
                                    id='professional-indemnity'
                                >
                                    <div
                                        className='relative z-[700] flex flex-row items-center justify-start px-[2rem]'
                                    >
                                        {/* <div className='w-[40%] h-[1px] bg-gradient-to-r from-primaryRichBlue to-primaryRichGreen opacity-30' /> */}
                                        <h6
                                            className="playfair introTitle introTitleTxtSize"
                                        >
                                            Professional Indemnity
                                        </h6>
                                    </div>

                                    <div
                                        className='relative z-[700] flex flex-col items-center justify-center lg:px-[2rem] pb-[2rem]'
                                    >
                                        <div className='titleUnderline' />
                                        <p
                                            className='outfit bodyTxt'
                                        >
                                            {/* The Firm has a Professional Indemnity Insurance Cover of Five Hundred Thousand United States Dollars (US$ 500,000.00/-), with an option to increase cover value should the need arise. */}
                                            The Firm has a Tier One Professional Indemnity Cover, with an option to increase cover value should the need arise.
                                        </p>
                                    </div>
                                </section>
                            </div>

                            {/* Fees & Disbursements Information */}
                            <div className="xs:block lg:hidden relative z-[500] w-[80%] mx-auto h-[1px] bg-gradient-to-r from-slate-400/20 via-slate-400 to-slate-400/20 opacity-50 xs:my-[2rem] lg:my-[4rem]" />
                            <div
                                className='bg-gradient-to-b from-white to-chunkSky/60 shadow-2xl border-[3px] border-white glsOutline relative z-[500] 2xl:py-[1.5rem] xs:px-[1.5rem] md:px-[5rem] lg:px-[1rem] 2xl:px-[3rem] xs:rounded-[12px] lg:rounded-[24px]'
                            >
                                <section
                                    id='fees-disbursements'
                                >
                                    <div
                                        className='relative z-[700] flex flex-row items-center justify-start px-[2rem] pt-[1.5rem]'
                                    >
                                        {/* <div className='w-[30%] h-[1px] bg-gradient-to-r from-primaryRichBlue to-primaryRichGreen opacity-30' /> */}
                                        <h6
                                            className="playfair introTitle introTitleTxtSize"
                                        >
                                            Fees &amp; Disbursements
                                        </h6>
                                        {/* <div className='w-[60%] h-[1px] bg-gradient-to-r from-primaryRichGreen to-primaryRichBlue opacity-30' /> */}
                                    </div>
                                    <div
                                        className='relative z-[700] flex flex-col items-center justify-center lg:px-[2rem]'
                                    >
                                        <div
                                            className='titleUnderline'
                                        />
                                        <p
                                            className='outfit bodyTxt text-justify pb-[2rem]'
                                        >
                                            The Advocates Remuneration (Amendment) Order prescribes and governs the fees we charge in most Commercial and Conveyancing matters. In addition to our professional fees, disbursements will be charged on reasonable prevailing costs for stationery, courier, document production, telephone and postal charges.
                                            <br />
                                            <br />
                                            The Remuneration Order also makes provision for Advocates to charge fees on a time expended basis and or based on the following factors:-
                                            <ul className='mt-[0.5rem] mb-[1rem] ml-[2rem] list-disc'>
                                                <li>Nature or importance and/or urgency of the matter.</li>
                                                <li>The interest of the parties.</li>
                                                <li>Time spent – per hour or per day.</li>
                                                <li>Complexity and intricacy of the matter.</li>
                                            </ul>
                                            For matters not governed by the said Order, we usually charge on a time expended basis however we are always prepared to work with Clients to structure transactions to save costs and where permitted by the Remuneration Order, negotiate with Clients on fee amounts and structure.
                                            <br />
                                            <br />
                                            In the event that additional legal or other professionals are retained, you will be responsible for payment of their fees and disbursements.
                                        </p>
                                    </div>
                                </section>
                            </div>
                        </div>


                        <section
                            id='legal-bugle'
                        >
                            <div className="divider" />
                            <div
                                className='pgMx'
                            >
                                <div
                                    className='bg-gradient-to-b from-white to-bgSky/60 shadow-2xl border-[3px] border-white glsOutline relative z-[500] lg:py-[0.5rem] 2xl:py-[1.5rem] xs:px-[1.5rem] md:px-[5rem] lg:px-[1rem] xl:px-[1.5rem] 2xl:px-[3rem] xs:rounded-[12px] lg:rounded-[24px] xs:mb-[2rem] lg:mb-[3rem] xl:mb-[4rem]'
                                >
                                    <div
                                        className='relative z-[700] flex flex-col items-start justify-start lg:px-[2rem] py-[1.5rem]'
                                    >
                                        {/* <div className='w-[40%] h-[1px] bg-gradient-to-r from-primaryRichBlue to-primaryRichGreen opacity-30' /> */}
                                        <div
                                            className='relative z-[700] flex flex-col items-start justify-center'
                                        >
                                            {/* <div className='w-[40%] h-[1px] bg-gradient-to-r from-primaryRichBlue to-primaryRichGreen opacity-30' /> */}
                                            <h5
                                                className="playfair introTitle introTitleTxtSize !text-left"
                                            >
                                                Legal Bugle
                                            </h5>
                                            <h6
                                                className="alata xs:text-[0.7rem] xsp:text-[0.8rem] md:text-[1rem] lg:text-[0.8rem] xl:text-[0.9rem] 2xl:text-[1rem] text-primaryGreen xs:leading-[0.75rem] xsp:leading-[0.85rem] lg:leading-[0.9rem] xl:leading-[1rem]"
                                            >
                                                Our Running Commentary on Contemporary Legal Issues &amp; Decisions from Kenyan Courts
                                            </h6>
                                        </div>
                                        <div className='titleUnderline' />
                                        {userText.title && (
                                            <h6 className='outfit w-full xs:text-[0.725rem] xsp:text-[0.825rem] md:text-[0.95rem] lg:text-[0.825rem] xl:text-[0.85rem] 2xl:text-[0.95rem] uppercase font-[700] tracking-[1px] mb-[1rem] pb-[0.75rem] border-b border-slate-600/40 text-slate-500'>
                                                {userText.title}
                                            </h6>
                                        )}
                                        <div className="outfit flex xs:flex-col lg:flex-row w-full gap-x-[2rem] mt-[1rem]">
                                            {userText.text ? (
                                                <>
                                                    {/* Image Container (40% Width) */}
                                                    {userText.imageURL ? (
                                                        <div className="lg:flex-[1.5] 2xl:flex-[2] flex items-center justify-center overflow-hidden border border-slate-600/30 rounded-[6px]">
                                                            <img
                                                                src={userText.imageURL}
                                                                alt="Legal News"
                                                                className="w-full h-full object-cover object-center"
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div className="xsm:w-full md:w-[60%] md:mx-auto lg:w-full lg:flex-[1.5] 2xl:flex-[2] flex items-center justify-center overflow-hidden border border-slate-600/30 rounded-[6px]">
                                                            <img
                                                                src={placeholderImage}
                                                                alt="Legal News"
                                                                className="w-full h-full object-cover object-center"
                                                            />
                                                        </div>
                                                    )}

                                                    {/* Text Container (60% Width) */}
                                                    <div className="flex-[3] xs:pt-[1rem]">
                                                        {userText.title === '' && (
                                                            <div className="border-t border-slate-600/20 pt-[1rem]" />
                                                        )}

                                                        {userText.text.split("\n").map((paragraph, index) => (
                                                            <p key={index} className="mb-2 text-justify bodyTxt">
                                                                {paragraph}
                                                            </p>
                                                        ))}
                                                    </div>
                                                </>
                                            ) : (
                                                <p>No text saved yet.</p>
                                            )}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </section>

                        <section
                            id='contact-us'
                        >
                            <div className="divider" />
                            <Contact />
                        </section>
                    </div>
                </motion.div>
            </AnimatePresence>
        </div>
    )
}

export default Home